import { Controller } from 'stimulus';
import DefaultCC from '../images/dividend/ic_cc.svg';
import AmexCC from '../images/dividend/ic_cc_amex.svg';
import VisaCC from '../images/dividend/ic_cc_visa.svg';
import DiscoverCC from '../images/dividend/ic_cc_discover.svg';
import McCC from '../images/dividend/ic_cc_mastercard.svg';

class InputHandlerController extends Controller {
  static targets = [
    'ccImage',
    'ccNumber'
  ]

  getCardType(number) {
    let re = new RegExp("^4");
    if (number.match(re) != null)
      return "visa";
    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    if (/^(5[1-5])/.test(number))
      return "mc";
    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
      return "amex";
    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
      return "discover";
    return null;
  }

  fillCardImage() {
    const { value } = this.ccNumberTarget;
    const type = this.getCardType(value);
    const typeToImage = {
      visa: VisaCC,
      mc: McCC,
      amex: AmexCC,
      discover: DiscoverCC,
      default: DefaultCC
    }
    const imageSrc = typeToImage[type || 'default'];
    if (this.ccImageTarget.src != imageSrc) {
      this.ccImageTarget.src = imageSrc;
    }
  }

  connect() {
    this.fillCardImage();
  }
}

export default InputHandlerController;
